import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import Repo from "../Repository/Repo";

// Define the initial state
const initialState = {
  user: null,
  loading: false,
  error: null,
};

// Async thunk for fetching user data
export const getUser = createAsyncThunk(
  "user/getUser",
  async (_, { rejectWithValue }) => {
    try {
      // Retrieve the email from localStorage
      const email = localStorage.getItem("email");
      if (!email) {
        throw new Error("Email not found in localStorage.");
      }

      // Make the API call with the _id from localStorage
      const { data } = await Repo.user({
        request: {
          method: "getUser",
          data: { _id: email },
        },
      });
      console.log("Response", data);

      // Return the user data from the API response
      return data.response.data.user;
    } catch (error) {
      // Handle errors
      return rejectWithValue(error.message);
    }
  }
);

// Create the slice
const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    userAdd: (state, action) => {
      state.user = action.payload;
    },
    userLogged: (state, action) => {
      state.isLoggedIn = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getUser.pending, (state) => {
        state.loading = true;
        state.error = "";
      })
      .addCase(getUser.fulfilled, (state, action) => {
        state.loading = false; // API call completed
        state.user = action.payload; // Update the `user` state with the response data
      })
      .addCase(getUser.rejected, (state, action) => {
        state.loading = false; // Stop loading on error
        state.error = action.error?.message || "Failed to fetch user"; // Update error state
      });
  },
});

export const { userAdd, userLogged } = userSlice.actions;

export default userSlice.reducer;
